import { rei } from "@/services/api"

class GerenciadorService {
  static getCargaCrc (busca) {
    !busca.sync_crc ? busca.sync_crc = 0 : ``
    return rei.post(`index-cargas`, busca).then(res => res.data)
  }

  static getTarefas (params) {
    return rei.get(`tarefas`, { params }).then(res => res.data)
  }
}

export default GerenciadorService
